import { useSeason } from '../../hooks/useSeason';
import { ADVENT, adventDayOverride, playAdventDay, themeDate } from '../../lib/advent';

/** 25 doors above the calendar. Does not replace family events. */
export function AdventStrip() {
  const season = useSeason();
  if (season.month !== 12) return null;

  const today = themeDate(new Date(), window.location.search).getDate();
  const preview = adventDayOverride(window.location.search);

  return (
    <div className="flex shrink-0 gap-1 overflow-x-auto px-2 py-1.5" data-advent-strip>
      {ADVENT.map((scene) => {
        const open = scene.day < today || (preview != null && scene.day === preview);
        const isToday = scene.day === today || (preview != null && scene.day === preview);
        const future = scene.day > today && !isToday;
        return (
          <button
            key={scene.day}
            type="button"
            disabled={future}
            title={scene.label}
            onClick={() => playAdventDay(scene.day)}
            className={
              isToday
                ? 'flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-violet-600 text-sm font-bold text-white'
                : open
                  ? 'flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-slate-800 text-xs font-semibold text-emerald-300'
                  : 'flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-slate-800/60 text-xs text-slate-500'
            }
          >
            {isToday ? scene.glyph : open ? '✓' : scene.day}
          </button>
        );
      })}
    </div>
  );
}
